var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.336 3.785a1.595 1.595 0 00-.888.43c-.042.04-1.696 1.918-3.676 4.175l-3.6 4.104-.052.024c-.122.057-.203.055-.273-.007a5713.7 5713.7 0 01-7.239-8.25 1.29 1.29 0 00-.55-.376c-.362-.126-.778-.093-1.166.094-.49.236-.783.626-.865 1.152a1.987 1.987 0 000 .456c.036.248.132.498.265.69.022.03 1.89 2.132 4.153 4.668l4.171 4.679c.291.335.644.53 1.092.605.138.023.444.021.583-.004a2.267 2.267 0 001.04-.479c.05-.042 1.139-1.27 4.138-4.668 2.238-2.535 4.104-4.646 4.147-4.69.164-.172.279-.355.357-.57L20 5.743V4.93l-.024-.07c-.2-.572-.738-1.01-1.324-1.075a1.737 1.737 0 00-.316.001z",
    fill: "currentColor"
  })));
}
export default SvgArrowDownBold;